import { render, staticRenderFns } from "./OutcomeList.vue?vue&type=template&id=20a8b60a&scoped=true"
import script from "./OutcomeList.vue?vue&type=script&lang=js"
export * from "./OutcomeList.vue?vue&type=script&lang=js"
import style0 from "./OutcomeList.vue?vue&type=style&index=0&id=20a8b60a&prod&scoped=true&lang=css"
import style1 from "./OutcomeList.vue?vue&type=style&index=1&id=20a8b60a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8b60a",
  null
  
)

export default component.exports